<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m7.3 6.687-4.255.917A1.327 1.327 0 0 0 2.03 9.18l2.526 11.662c.156.715.862 1.17 1.577 1.015l6.202-1.344"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.438 9.333a.332.332 0 0 1 .396.255M4.183 9.732a.332.332 0 0 1 .255-.4M4.58 9.987a.332.332 0 0 1-.396-.255"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.834 9.59a.333.333 0 0 1-.255.397M21.379 8.062l-8.412-2.681a.889.889 0 0 0-1.117.577L7.962 18.16c-.149.467.11.967.577 1.116l8.412 2.682a.889.889 0 0 0 1.117-.577l3.889-12.202a.889.889 0 0 0-.577-1.117Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      clip-rule="evenodd"
      d="m15.765 11.143-2.7 1.922 1.09 3.131 2.7-1.923-1.09-3.13Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.729 7.709a.334.334 0 0 1 .216.419M13.31 7.925a.333.333 0 0 1 .418-.216"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.527 8.344a.332.332 0 0 1-.217-.42"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.945 8.128a.333.333 0 0 1-.419.216M16.394 18.994a.333.333 0 0 1 .216.42M15.975 19.211a.334.334 0 0 1 .418-.216M16.19 19.63a.333.333 0 0 1-.215-.419"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.61 19.413a.334.334 0 0 1-.42.217M17.91 6.956v-3.63A1.38 1.38 0 0 0 16.576 2H8.711A1.395 1.395 0 0 0 7.3 3.318V15.25a1.326 1.326 0 0 0 1.167 1.325"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.69 3.994a.333.333 0 0 1 .33.335M9.357 4.325a.333.333 0 0 1 .333-.33M9.689 4.66a.335.335 0 0 1-.332-.335"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.024 4.33a.334.334 0 0 1-.336.33"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
